__turbopack_context__.v({
  "content_metadata": "JGyxCG_content_metadata",
  "content_metadata__follow_us": "JGyxCG_content_metadata__follow_us",
  "content_metadata__genre": "JGyxCG_content_metadata__genre",
  "content_metadata__genre_badges": "JGyxCG_content_metadata__genre_badges",
  "content_metadata__rating": "JGyxCG_content_metadata__rating",
  "content_metadata__share_this_video": "JGyxCG_content_metadata__share_this_video",
  "content_metadata__share_this_video__links": "JGyxCG_content_metadata__share_this_video__links",
  "content_metadata__share_this_video__links__embed_button": "JGyxCG_content_metadata__share_this_video__links__embed_button",
  "content_metadata__social_stuff": "JGyxCG_content_metadata__social_stuff",
  "content_metadata__sub_title": "JGyxCG_content_metadata__sub_title",
  "content_metadata__title": "JGyxCG_content_metadata__title",
  "copy_button": "JGyxCG_copy_button",
  "copy_button__copied_text": "JGyxCG_copy_button__copied_text",
});
